import { forwardRef, type HTMLAttributes } from 'react';

import { useIsMobile } from '@tmh-website/shared';

import * as Styled from './MenuLink.styles';

interface MenuLinkProps extends HTMLAttributes<HTMLAnchorElement> {
  isSelected: boolean;
  label: string;
  onStateChange: () => void;
}

const MenuLink = forwardRef<HTMLAnchorElement, MenuLinkProps>(({ isSelected, label, onStateChange, ...props }, ref) => {
  const isMobile = useIsMobile();

  return (
    <Styled.Container
      ref={ref}
      {...props}
      $isSelected={isSelected}
      onFocus={() => {
        // Focus is used for keyboard navigation
        if (isMobile) {
          return;
        }
        onStateChange();
      }}
      onMouseEnter={() => {
        if (isMobile) {
          return;
        }
        onStateChange();
      }}>
      {label}
    </Styled.Container>
  );
});

MenuLink.displayName = 'MenuLink';

export default MenuLink;
